import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-form"
export default class extends Controller {
  static targets = [ 'numberInputWrapper' ];
  declare readonly numberInputWrapperTarget: HTMLDivElement;

  connect() {
  }

  countryChange = e => {
    const selectedOpt = e.target.options[e.target.selectedIndex];
    const addon = this.numberInputWrapperTarget.querySelector('.addon'),
        numberInput = this.numberInputWrapperTarget.querySelector('input'),
        hint = this.numberInputWrapperTarget.querySelector('.hint');
    if (!!selectedOpt && !!addon) {
      const { countryCode, nationalNumberMin, nationalNumberMax, nationalNumberHint } = selectedOpt.dataset;
      addon.innerHTML = `+${countryCode}`;
      numberInput.setAttribute('minlength', nationalNumberMin);
      numberInput.setAttribute('maxlength', nationalNumberMax);
      numberInput.setAttribute('size', nationalNumberMax);
      if (hint) hint.innerHTML = nationalNumberHint;
    }
  }
}
